<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">User Objectives</span>
    </div>
    <div class="flex gap-2 items-center">
      <label nz-checkbox [(ngModel)]="includeTestUsers" (ngModelChange)="applyFilters()">
        Include test users
      </label>
      <button nz-button nzSize="small" nzType="primary" (click)="clearFilters()">
        Clear filters
      </button>
    </div>
  </div>
</ng-template>

<nz-card [nzTitle]="tableHead" [nzLoading]="pageLoading">
  <nz-table
    #userObjectivesTable
    [nzData]="data"
    [nzLoading]="tableLoading"
    [nzFrontPagination]="false"
    [nzTotal]="totalRecords"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzPageSizeOptions]="pageSizeOptions"
    (nzPageIndexChange)="nzPageIndexChange($event)"
    (nzPageSizeChange)="nzPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>
          User
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="emailMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Partner
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="partnerMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Tags
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="tagsMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Title
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="titleMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>Description</th>
        <th>
          Status
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="statusMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Progress
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="progressMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>Snapshot Status</th>
        <th>Started</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td>
          <div>{{ row.userName || '(unknown)' }}</div>
          <div class="text-xs text-gray-500">{{ row.userEmail || row.userId }}</div>
        </td>
        <td>{{ row.partnerId || '-' }}</td>
        <td>
          <nz-tag *ngFor="let tag of row.userTags">{{ tag }}</nz-tag>
          <span *ngIf="!row.userTags?.length">-</span>
        </td>
        <td>{{ row.displayTitle || '-' }}</td>
        <td>{{ row.displayDescription || '-' }}</td>
        <td>{{ row.status }}</td>
        <td>{{ row.latestSnapshot?.progress ?? '-' }}</td>
        <td>{{ row.latestSnapshot?.status || '-' }}</td>
        <td>{{ row.startDate | date: 'medium' }}</td>
        <td>
          <button
            nz-button
            nzType="default"
            nzDanger
            [disabled]="!canRetire(row)"
            (click)="retireAlert(row)"
          >
            Retire
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>

<nz-dropdown-menu #emailMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="userEmailSearch"
          nz-input
          placeholder="Search by email"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #partnerMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="partnerIdSearch"
          nz-input
          placeholder="Search by partner"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #tagsMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onUserTagsFilterChange($event)">
      <div *ngFor="let tag of userTagsOptions" nz-row class="m-1">
        <label nz-checkbox [nzValue]="tag" [ngModel]="userTagsFilterValues.includes(tag)">
          {{ tag }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #titleMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <div class="text-xs text-gray-500 mb-1">Title contains</div>
        <input
          [(ngModel)]="displayTitleSearch"
          nz-input
          placeholder="Search by title"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row>
      <div nz-col>
        <div class="text-xs text-gray-500 mb-1">Objective expert title contains</div>
        <input
          [(ngModel)]="expertTitleSearch"
          nz-input
          placeholder="Search by expert title"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #statusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onStatusFilterChange($event)">
      <div *ngFor="let status of statusOptions" nz-row class="m-1">
        <label nz-checkbox [nzValue]="status" [ngModel]="statusFilterValues.includes(status)">
          {{ status }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #progressMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onProgressBucketFilterChange($event)">
      <div *ngFor="let bucket of progressBucketOptions" nz-row class="m-1">
        <label
          nz-checkbox
          [nzValue]="bucket"
          [ngModel]="progressBucketFilterValues.includes(bucket)"
        >
          {{ bucket === UserObjectivesProgressBucket.NO_DATA ? 'No data' : bucket + '%' }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
